import { BaseRequest } from '@/network/requests/BaseRequest'
import { defect_statis } from '@/interfaces/defect_statis'
import { FilterQuery } from '../interfaces/FilterQuery'

export const defectStatisRequest = BaseRequest.build<defect_statis>('defect_statis')

/**
 *
 * @param code
 */
export const getDefectStatisByJobOrderId = (job_order_id?: string) => {
	let filter: any = undefined
	if (job_order_id) {
		filter = {
			job_order_id,
		}
	}

	return defectStatisRequest.queryAll(filter)
}

type JobOrderIdDefectStatisMap = {
	[props: string]: defect_statis[];
}

export const queryAllDefectStatisListByJobOrderIdList = async (jobOrderIds: string[]) => {
	if (jobOrderIds.length === 0) {
		throw new Error("工单号不能为空！");
	}
	return defectStatisRequest.queryAll({
		job_order_id: {
			$in: jobOrderIds
		}
	});
}

export const groupDefectStatisListByJobOrderId = (defectStatisList: defect_statis[]) => {
	return defectStatisList.reduce((acc, curr) => {
		if (acc[curr.job_order_id!] === undefined) {
			acc[curr.job_order_id!] = [];
		}
		acc[curr.job_order_id!].push(curr);
		return acc;
	}, {} as JobOrderIdDefectStatisMap);
}